export default {
  membershipSet (state) {
    return state.memberships.ids.map((id) => state.memberships.index[id])
  },

  notDeletedMemberships (state, getters) {
    return getters.membershipSet.filter((membership) => {
      return membership.deleted_at === null
    })
  },

  getMembershipByID (state, getters) {
    return (id) => {
      return getters.membershipSet.find((membership) => {
        return membership.tenant.id === id
      })
    }
  },

  getMembershipByName (state, getters) {
    return (name) => {
      return getters.membershipSet.find((membership) => {
        return membership.tenant.name === name
      })
    }
  },

  getCurrentRole (state, getters, rootState) {
    if (state.data.is_owner) {
      return 'owner'
    }

    if (rootState.tenants.current) {
      const tenantID = rootState.tenants.current.id
      const membership = getters.getMembershipByID(tenantID)
      if (membership) {
        return membership.role
      }
    }

    return null
  },

  isEmpty (state) {
    return Object.keys(state.data).length === 0
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/client/getters.js